module.exports = __webpack_public_path__ + "static/img/XAVIER-LINDSAY.ee44f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XAVIER-LINDSAY.jpg
// module id = aYxD
// module chunks = 0